import { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login } from "../service/auth.servide";
import { AuthContext } from "../context/AuthContext";
import { saveUser } from "../utils/authUtils";
import Logo from "./Logo.jsx";
import ReactGA from "react-ga4";
import "../style/userForms.css";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

import { globalT } from "../utils/globalUtils.js";

export const LoginForm = () => {
  const navigate = useNavigate();
  const [postErrors, setPostErrors] = useState(false);
  const { setUserLog } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const currentLanguage = localStorage.getItem("i18nextLng");

  const { i18n } = useTranslation();

  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    password: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    document.querySelector(".m-userform").classList.add("loading");
    event.preventDefault();
    try {
      const { data } = await login(formData);
      document.querySelector(".m-userform").classList.remove("loading");

      const localStorage = {
        email: formData.email,
        name: data.userName,
        userId: data.token,
      };

      saveUser(localStorage);
      setUserLog(true);

      ReactGA.event({
        category: "Usuario",
        action: "Acceder a través de login",
      });

      navigate("/");
    } catch (e) {
      document.querySelector(".m-userform").classList.remove("loading");
      e.response && setPostErrors(e.response.data.message);
    }
  };

  const toggleLanguage = (newLang, el) => {
    document.querySelectorAll(".row-lang span").forEach(span => span.classList.remove("active"));
    el.target.classList.add("active");
    i18n.changeLanguage(newLang);
    localStorage.setItem("i18nextLng", newLang);
  };

  return (
    <div className="m-userform">
      <Logo />

      <div className="my-2 text-center">
        <span>{globalT("Elige tu versión")}</span>
        <div className="row-lang">
          <span onClick={(el) => toggleLanguage("es", el)} className={currentLanguage === "es" ? "active" : ""}>
            {globalT("Español")}
          </span>
          <span onClick={(el) => toggleLanguage("en", el)} className={currentLanguage === "en" ? "active" : ""}>
           English
          </span>
        </div>
      </div>

      <div className="m-title">Login</div>
      <div className="m-subtitle">{globalT("¿Preparado para empezar?")}</div>

      <form className="m-form main-form" onSubmit={handleSubmit}>
        <div className="m-input-group">
          <label>Email *</label>
          <input
            required
            type="email"
            name="email"
            placeholder={globalT("Escribe aquí tu email")}
            value={formData.email}
            onChange={handleInputChange}
          />
        </div>
        <div className="m-input-group">
          {" "}
          <div className="m-eye" onClick={togglePasswordVisibility}></div>
          <label>Password *</label>
          <input
            required
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder={globalT("Escribe aquí tu contraseña")}
            value={formData.password}
            onChange={handleInputChange}
          />
        </div>
        <div className="m-link">
          <Link to="/forgot-password"> {globalT("Recuperar contraseña")}</Link>
        </div>
        <div className="m-link">
          {globalT(" Si aún no tienes cuenta, por favor")}
          <Link to="/register"> {globalT("Regístrate aquí")}</Link>
        </div>
        {postErrors && <div className="m-error">{postErrors}</div>}{" "}
        <button className="m-button" type="submit">
          {globalT("Enviar")}
        </button>
      </form>
    </div>
  );
};
